import { PortalSellerGroupContext } from './portal.types';
import { buildLocalPortalDashboardUrl } from './portal-local-context';

interface PortalRedirectTarget {
  label: string;
  url: string;
  isAvailable: boolean;
  unavailableReason?: string;
}

const getConfiguredProductUrl = (profile: 'LOG' | 'GO') =>
  profile === 'LOG'
    ? process.env['NX_LOG_DASHBOARD_URL']
    : process.env['NX_GO_DASHBOARD_URL'];

const getProductUrl = (context: PortalSellerGroupContext) => {
  if (context.profile === 'PAY') return 'about:blank';
  return getConfiguredProductUrl(context.profile) ?? '';
};

// Local runtime uses configured dashboard ports as the base for query-string
// context handoff.
const getLocalProductUrl = (context: PortalSellerGroupContext): string => {
  const localPath = buildLocalPortalDashboardUrl(context);
  if (context.profile === 'PAY') return localPath;
  const base = getConfiguredProductUrl(context.profile);
  return base ? new URL(localPath, base).toString() : localPath;
};

export const getPortalRedirectTarget = (
  context: PortalSellerGroupContext,
  mode: 'local' | 'production' = 'production',
): PortalRedirectTarget => {
  const url =
    mode === 'local' ? getLocalProductUrl(context) : getProductUrl(context);

  if (context.profile === 'PAY' || context.status === 'unavailable') {
    return {
      label: context.name,
      url,
      isAvailable: false,
      unavailableReason: context.status_label || 'Produto ainda nao disponivel',
    };
  }

  return {
    label: `${context.name}${context.is_homologation ? ' Homologacao' : ''}`,
    url,
    isAvailable: true,
  };
};
